export default __webpack_public_path__ + "static/yawencode-8319692027c9210d4078b269c2902562.png";